import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "@/context/ConfigContext";
import Landing from "@/pages/Landing";
import Order from "@/pages/Order";
import PaymentCallback from "@/pages/PaymentCallback";
import Confirmation from "@/pages/Confirmation";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <ConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/order" element={<Order />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </ConfigProvider>
    </div>
  );
}

export default App;
